// extracted by mini-css-extract-plugin
module.exports = {"section":"SummaryAndActions_section__1hlI8","fadeIn":"SummaryAndActions_fadeIn__2Z1bN","fadeOut":"SummaryAndActions_fadeOut__1cUsL"};